import { forwardRef } from 'react';
import { clsx } from 'clsx';
import { Loader2 } from 'lucide-react';

const variants = {
  primary: 'bg-primary text-primary-foreground hover:bg-primary-hover active:bg-primary-pressed focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2',
  secondary: 'bg-surface text-text-primary border border-border hover:bg-bg-secondary active:bg-bg focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2',
  ghost: 'bg-transparent text-primary hover:bg-primary-subtle active:bg-primary-subtle focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2',
  danger: 'bg-danger text-white hover:bg-[#DC2626] active:bg-[#B91C1C] focus-visible:ring-2 focus-visible:ring-danger focus-visible:ring-offset-2',
  link: 'bg-transparent text-primary underline-offset-4 hover:underline p-0 h-auto focus-visible:ring-2 focus-visible:ring-border-focus focus-visible:ring-offset-2',
};

const sizes = {
  sm: 'h-8 px-3 text-sm rounded',
  md: 'h-10 px-5 text-base rounded-md',
  lg: 'h-12 px-6 text-lg rounded-md',
};

const Button = forwardRef(({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  className,
  children,
  ...props
}, ref) => {
  const isDisabled = disabled || loading;

  return (
    <button
      ref={ref}
      disabled={isDisabled}
      className={clsx(
        'inline-flex items-center justify-center gap-2 font-semibold transition-colors duration-normal',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        variant !== 'link' && sizes[size],
        className,
      )}
      {...props}
    >
      {loading && <Loader2 size={16} className="animate-spin shrink-0" aria-hidden="true" />}
      {children}
    </button>
  );
});

Button.displayName = 'Button';

export default Button;
